import React, { useEffect } from 'react';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
    __mp_pixel_initialized?: boolean;
    __mp_view_content_sent?: boolean;
    __mp_last_checkout_event?: number;
  }
}
const PIXEL_ID = '2820238711690534';
// ---------------------------------------------------------------------------
// Initialize at module-load time (NOT inside useEffect) so the Pixel fires as
// soon as the JS bundle executes — before React mounts. This guarantees that
// Meta Pixel Helper detects an active pixel + PageView + ViewContent even if a
// user bounces quickly, and that Meta Ads receives Landing Page Views reliably.
//
// A guard on `window.__mp_pixel_initialized` prevents double init from HMR,
// re-imports or Strict Mode re-renders.
// ---------------------------------------------------------------------------
if (typeof window !== 'undefined' && !window.__mp_pixel_initialized) {
  window.__mp_pixel_initialized = true;
  (function (f: any, b: Document, e: string, v: string) {
    let n: any, t: HTMLScriptElement, s: HTMLScriptElement | null;
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e) as HTMLScriptElement;
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0] as HTMLScriptElement;
    s?.parentNode?.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  // Initialize the pixel
  window.fbq('init', PIXEL_ID);
  // Standard PageView — fires exactly once per page load, guarded by
  // `__mp_pixel_initialized` so HMR / re-imports cannot duplicate it.
  window.fbq('track', 'PageView');
}

// ---------------------------------------------------------------------------
// ViewContent — fired once, only after the landing has actually loaded and the
// main content is on screen. The `window.__mp_view_content_sent` flag lives
// outside React, so Strict Mode double-mounts and any re-render cannot
// duplicate the event.
// ---------------------------------------------------------------------------
function trackViewContentOnce() {
  if (typeof window === 'undefined') return;
  if (window.__mp_view_content_sent) return;
  if (!window.fbq) return;
  window.__mp_view_content_sent = true;
  window.fbq('track', 'ViewContent', {
    content_name: 'Mega Pack Enfermería',
    content_category: 'Educación · Enfermería',
    content_ids: ['mega-pack-enfermeria'],
    content_type: 'product',
    value: 12.99,
    currency: 'USD'
  });
}
// ---------------------------------------------------------------------------
// Component — only renders the <noscript> fallback. All initialization happens
// at module load above. This component is included in App so the noscript img
// renders into the DOM for clients with JS disabled.
// ---------------------------------------------------------------------------
export function MetaPixel() {
  useEffect(() => {
    // If the document is already loaded (typical for a client-side mount),
    // send ViewContent right away; otherwise wait for the load event so the
    // event only fires once the main content is really rendered.
    if (document.readyState === 'complete') {
      trackViewContentOnce();
      return;
    }
    window.addEventListener('load', trackViewContentOnce, {
      once: true
    });
    return () => window.removeEventListener('load', trackViewContentOnce);
  }, []);
  return <noscript data-id="element-139" data-mp="7jivtjw5wp6e">
      <img height="1" width="1" style={{
      display: 'none'
    }} alt="" src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-140" data-mp="7izosy81vl75" />
    </noscript>;
}
// Helper used by every checkout CTA (see utils/checkout.ts) to fire
// InitiateCheckout. Safe to call before the pixel has finished loading — the
// fbq queue keeps the event until the script is ready.
export function trackPixelEvent(event: string, params?: Record<string, any>) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', event, params);
  }
}